module.exports = __webpack_public_path__ + "img/avalanche.ff7cbe48.svg";